import { render, staticRenderFns } from "./CourseAuthoritySetting.vue?vue&type=template&id=6fc48357"
import script from "./CourseAuthoritySetting.vue?vue&type=script&lang=ts"
export * from "./CourseAuthoritySetting.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports